module.exports = __webpack_public_path__ + "img/GH-corporate-002-new.e142f2c2.png";